<template>
  <v-app id="app">
    <app-header app></app-header>
    <v-content>
      <app-error-snackbar></app-error-snackbar>
      <app-success-snackbar></app-success-snackbar>
      <v-container fluid id="mainContainer">
        <router-view></router-view>
      </v-container>
    </v-content>
    <app-footer app></app-footer>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import {mapActions} from "vuex";

export default {
  name: "App",
  components: {
    appHeader: Header,
    appFooter: Footer,
  },
  data: () => ({
    sideNav: true,
  }),
  created() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions(["updateWindowWidth", "updateScrollY"]),
    handleResize() {
      this.updateWindowWidth(window.innerWidth);
    },
    handleScroll() {
      this.updateScrollY(window.scrollY);
    }
  },
  metaInfo() {
    return {
      title: "Official website of Dr. Rashmee Rajkarnikar",
      meta: [
        {
          name: "description",
          content: "This is the official website of Dr. Rashmee Rajkarnikar, sometimes also referred to as Rashmi Shilpakar (Rajkarnikar). Dr. Rashmee is a Ph.D. holder in Economics having completed her doctorate degree from Tribhuvan Universtiy of Nepal. She is currently working as an assistant professor in Tribhuvan University."
        },
        {
          property: "og:title",
          content: "Official website of Dr. Rashmee Rajkarnikar"
        },
        {
          property: "og:site_name",
          content: "Dr. Rashmee Rajkarnikar"
        },
        {
          property: "og:type",
          content: "website"
        },
        {
          name: "robots",
          content: "index,follow"
        }
      ]
    }
  }
};
</script>

<style>
#app {
  background-color: white;
  font-family: "Hind-Regular" !important;
}
#mainContainer {
  padding: 0;
}
.pageHeader {
  margin: 0;
  padding: 0;
  min-width: 100%;
  min-height: 100px;
}
@font-face {
  font-family: "Hind-Bold";
  src: url("~@/assets/fonts/Hind-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "Hind-Light";
  src: url("~@/assets/fonts/Hind-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Hind-Medium";
  src: url("~@/assets/fonts/Hind-Medium.ttf") format("truetype");
}
@font-face {
  font-family: "Hind-Regular";
  src: url("~@/assets/fonts/Hind-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Hind-SemiBold";
  src: url("~@/assets/fonts/Hind-SemiBold.ttf") format("truetype");
}
</style>
